import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import { agentsData } from "Stores/agentsData";
import AgentSelect from "./AgentSelect";
import { defaultTimezone } from "./DayOfWeekField";
import { SetupPage, When, Step, SequenceField, NotifyStep, openInBuilder } from "./SetupFlow";
import TriggerFilters from "./TriggerFilters";
import { eventLabel as labelOfEvent, eventOptions, filterConfigFor } from "./triggerCatalog";


const CreateEventAgent = observer(() => {
  const history = useHistory();
  const [eventType, setEventType] = useState("EMAIL_REPLIED");
  const [eventConfig, setEventConfig] = useState({}); // trigger filters, e.g. { toStages: ["Working"] }
  const [name, setName] = useState("");
  const [sequenceId, setSequenceId] = useState("");
  const [sequenceName, setSequenceName] = useState("");
  const [notifyMode, setNotifyMode] = useState("ON_FAILURE");
  const [saving, setSaving] = useState(false);
  const timezone = defaultTimezone();

  useEffect(() => { agentsData.fetchTriggerTypes(); agentsData.fetchSequencesLite(); }, []);

  const eventLabel = labelOfEvent(eventType);
  const canSubmit = !!eventType;

  const buildPayload = () => ({
    name: name.trim() || `When ${eventLabel.toLowerCase()}`,
    eventType,
    ...filterConfigFor(eventType, eventConfig),
    sequenceId: sequenceId || undefined,
    notifyMode,
    timezone
  });

  const submit = async () => {
    if (!canSubmit) return;
    setSaving(true);
    const agent = await agentsData.createEventAgent(buildPayload());
    setSaving(false);
    if (agent && agent.id) history.push(`/agents/${agent.id}`);
  };

  const customize = () => { if (canSubmit) openInBuilder(history, "event-agent", buildPayload(), setSaving); };

  return (
    <SetupPage
      title="Hire · Event agent"
      name={{ value: name, onChange: setName, placeholder: `When ${eventLabel.toLowerCase()}` }}
      bar={{ canSubmit, saving, onCreate: submit, onCustomize: customize, customizeDisabled: !canSubmit, onCancel: () => history.push("/agents"), reason: "Pick an event to create it." }}>
      <When icon="bolt">
        <AgentSelect value={eventType} searchable searchPlaceholder="Search events…"
          onChange={v => { setEventType(v); setEventConfig({}); }} options={eventOptions()} />
        <TriggerFilters eventType={eventType} config={eventConfig} onChange={setEventConfig} />
      </When>
      <Step icon="send" tone="amber" title="Add to a sequence" tags={[{ label: "Optional" }]}>
        <SequenceField id={sequenceId} name={sequenceName} placeholder="No sequence, just tell me"
          onPick={s => { setSequenceId(s.id); setSequenceName(s.name); }}
          onClear={() => { setSequenceId(""); setSequenceName(""); }} clearLabel="Clear, just notify me" />
      </Step>
      <NotifyStep value={notifyMode} onChange={setNotifyMode} />
    </SetupPage>
  );
});

export default CreateEventAgent;
